import React, {Component} from 'react'
import CPageNew from '@/components/CPageNew'
import CBaseComponent from '@/components/CBaseComponent'
import { storeManageListNewData} from './data'
import './index.scss'
import { getStorage,gotonext} from "@/utils";
import {getInfo} from "../../../../servers/menuAPI";
import {savedataspecial} from "../../../../servers/commonApi";
import {bindActionCreators, compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {message, Modal} from "antd";
import {dpespecialaddlist} from "../../../../utils/dpedatadef";
import {removeStorage} from "../../../../utils";
import {
  refreshMenu,
} from "../../../../redux/common/action";
@CBaseComponent
class Legal extends Component{

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onChangeEdit = this.onChangeEdit.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onChange = this.onChange.bind(this)
  }


  state = {
    data: storeManageListNewData,
  }

  onChangeEdit(data){
  }
  onChange(data){
    const params = {}
    params.annual = localStorage.getItem('year')
    params.itemlist = [{indicatorid:data.value,fillin:''}]
    if (!data.data.uploadnum) {
      return false
    }
    savedataspecial(params).then(res=>{
      if(res.statecode === 0) {
        sessionStorage.setItem('id_'+data.data.uploadnum,res.records[0])
      } else {
        message.error(res.statemessage);
      }
    })
  }

  onSelect(){
    const params = {
      annual:localStorage.getItem('year'),
      indid:'4.1'
    }
    getInfo(params).then(res=>{
      if (res.statecode === 0) {
        let data = []
        if (res.records.length > 0) {
          res.records.forEach((item,index)=>{
            const obj = {}
            const obj1 = {}
            const obj2 = {}
            const obj3 = {}
            obj.id = index===0?'indicatorid1': index===1?'indicatorid5':index===2?'indicatorid9':index===3?'indicatorid13':'indicatorid17'
            obj.name = '类型'
            obj.placeholder=''
            obj.type= 'select'
            obj.checkType= ''
            obj.newDisabled=false
            obj.editDisabled=false
            obj.newShow=true
            obj.editShow=true
            obj.ifEdit=false
            obj.value= item.code
            obj.options= dpespecialaddlist
            obj.expand = {}
            obj.hasupload = ''
            obj.jpath = index===0?'indicatorid1': index===1?'indicatorid5':index===2?'indicatorid9':index===3?'indicatorid13':'indicatorid17'
            obj.tips = ''

            obj1.id = index===0?'itemname0': index===1?'itemname4':index===2?'itemname8':index===3?'itemname12':'itemname16'
            obj1.name =  `项目${index === 0 ?'一':index === 1?'二':index === 2?'三':index === 3?'四':index === 4?'五':''}名称`
            obj1.placeholder=''
            obj1.type= 'input'
            obj1.checkType= ''
            obj1.newDisabled=false
            obj1.editDisabled=false
            obj1.newShow=true
            obj1.editShow=true
            obj1.ifEdit=false
            obj1.value= item.itemname ? decodeURIComponent(item.itemname): ''
            obj1.options= []
            obj1.expand = {}
            obj1.hasupload = ''
            obj1.jpath = index===0?'itemname0': index===1?'itemname4':index===2?'itemname8':index===3?'itemname12':'itemname16'
            obj1.tips = ''
            obj1.showeditbtn = false

            obj2.id = index===0?'fillin2': index===1?'fillin6':index===2?'fillin10':index===3?'fillin14':'fillin18'
            obj2.name = '说明'
            obj2.placeholder=''
            obj2.type= 'textarea'
            obj2.checkType= ''
            obj2.newDisabled=false
            obj2.editDisabled=false
            obj2.newShow=true
            obj2.editShow=true
            obj2.ifEdit=false
            obj2.value= item.fillin ? decodeURIComponent(item.fillin): ''
            obj2.options= []
            obj2.expand = { autosize: {minRows: 4, maxRows: 10}}
            obj2.hasupload = ''
            obj2.jpath = index===0?'fillin2': index===1?'fillin6':index===2?'fillin10':index===3?'fillin14':'fillin18'
            obj2.tips = ''
            obj2.showeditbtn = false

            obj3.id= index===0?'_id3_'+item.id: index===1?'_id7_'+item.id:index===2?'_id11_'+item.id:index===3?'_id15_'+item.id:'_id119_'+item.id
            obj3.name=''
            obj3.placeholder=''
            obj3.type= 'img'
            obj3.checkType= ''
            obj3.newDisabled= false
            obj3.editDisabled= false
            obj3.newShow= true
            obj3.editShow= true
            obj3.value= item.annexlist
            obj3.options= []
            obj3.jpath= index===0?'_id3_'+item.id: index===1?'_id7_'+item.id:index===2?'_id11_'+item.id:index===3?'_id15_'+item.id:'_id19_'+item.id
            obj3.expand= {
              limit: 100
            }
            obj3.specialupload  = true
            obj3.btnname= '附件'
            data.push(obj1)
            data.push(obj)
            data.push(obj2)
            data.push(obj3)
          })
        }
        if (res.records.length === 5) {
          const obj = JSON.parse(JSON.stringify(this.state.data))
          obj[0].data = data
          this.setState({
            data:obj
          })
          return false
        }
        const arr =  20 - res.records.length*4
        for(let i = 0; i<arr;i++) {
          let obj = {}
          if (i === 0 || i === 4 || i === 8 || i === 12 || i === 16) {
            const r = res.records.length*4 + i
            obj.name = `项目${r === 0 ?'一':r === 4?'二':r === 8?'三':r === 12?'四':r === 16?'五':''}名称`
            obj.type= 'input'
            obj.id = 'itemname'+(i+res.records.length*4)
            obj.jpath = 'itemname'+(i+res.records.length*4)
            obj.expand = {}
          }

          if (i === 1 || i === 5 || i === 9 || i === 13 || i === 17) {
            obj.name = '类型'
            obj.type= 'select'
            obj.options= dpespecialaddlist
            obj.id = 'indicatorid'+(i+res.records.length*4)
            obj.jpath = 'indicatorid'+(i+res.records.length*4)
            obj.uploadnum = i+res.records.length*4 + 2
          }


          if (i === 2 || i === 6 || i === 10 || i === 14 || i === 18) {
            obj.name = '说明'
            obj.type= 'textarea'
            obj.id = 'fillin'+(i+res.records.length*4)
            obj.jpath = 'fillin'+(i+res.records.length*4)
            obj.expand = {
              autosize: {minRows: 4, maxRows: 10}
            }
          }
          obj.placeholder=''
          obj.checkType= ''
          obj.newDisabled=false
          obj.editDisabled=false
          obj.newShow=true
          obj.editShow=true
          obj.ifEdit= false
          obj.value= ''
          obj.hasupload = ''
          obj.tips = ''
          obj.showeditbtn = false
          if (i === 3 || i === 7 || i === 11 || i === 15 || i === 19) {
                obj.id= 'none'+i
                obj.name=''
                obj.placeholder=''
                obj.type= 'img'
                obj.checkType= ''
                obj.newDisabled= false
                obj.editDisabled= false
                obj.newShow= true
                obj.editShow= true
                obj.value= ''
                obj.options= []
                obj.jpath=''
                obj.expand= {
                  limit: 100
                }
                obj.specialupload  = true
                obj.specialuploadid = (i+res.records.length*4)
                obj.btnname= '附件'
          }
          data.push(obj)
        }
        const obj = JSON.parse(JSON.stringify(this.state.data))
        obj[0].data = data
        console.log(obj);
        this.setState({
          data:obj
        })
      }
    })
  }


  onSubmit(data){
    Modal.confirm({
      content: '确认提交数据',
      okText: '确认',
      cancelText: '取消',
      onCancel:()=>{
      },
      onOk:()=>{
        if (data.status) {
          let isEmpty = true;
          Object.keys(data.data).forEach(function(x) {
            if(data.data[x] != null && data.data[x] != ""){
              isEmpty = false;
            }
          });
          if (isEmpty) {
            message.error('您还未添加特色加分项');
            return false
          }
          const arr = []
          let keysarr = [];
          for (let key in data.data) {
            if (key.includes('_id')){
              keysarr.push(key)
            }
          }
          if (data.data.indicatorid1 !== ''){
            // if (data.data.itemname0 === '' || data.data.itemname0 === null || data.data.itemname0 === undefined) {
            //   message.error('特色加分项1中名字为空,请填写');
            //   return false
            // }
            // if (data.data.fillin2 === '' || data.data.fillin2 === null || data.data.fillin2 === undefined)  {
            //   message.error('特色加分项1中说明为空,请填写');
            //   return false
            // }
            let o = {indicatorid:data.data.indicatorid1,fillin:data.data.fillin2,name:data.data.itemname0}
            const session = sessionStorage.getItem('id_3')
            if (session!==null && session!=='') {
              o.id = session
            } else {
              keysarr.forEach(item=>{
                if (item.includes('id3')){
                  const a = item.split('_')
                  o.id = a[2]
                }
              })
            }
            arr.push(o)
          }
          if (data.data.indicatorid5 !== ''){
            // if (data.data.itemname4 === '' || data.data.itemname4 === null || data.data.itemname4 === undefined) {
            //   message.error('特色加分项2中名字为空,请填写');
            //   return false
            // }
            // if (data.data.fillin6 === '' || data.data.fillin6 === null || data.data.fillin6 === undefined)  {
            //   message.error('特色加分项2中说明为空,请填写');
            //   return false
            // }
            let o = {indicatorid:data.data.indicatorid5,fillin:data.data.fillin6,name:data.data.itemname4}
            const session = sessionStorage.getItem('id_7')
            if (session!==null && session!=='') {
              o.id = session
            } else {
              keysarr.forEach(item=>{
                if (item.includes('id7')){
                  const a = item.split('_')
                  o.id = a[2]
                }
              })
            }
            arr.push(o)
          }
          if (data.data.indicatorid9 !== ''){
            // if (data.data.itemname8 === '' || data.data.itemname8 === null || data.data.itemname8 === undefined) {
            //   message.error('特色加分项3中名字为空,请填写');
            //   return false
            // }
            // if (data.data.fillin10 === '' || data.data.fillin10 === null || data.data.fillin10 === undefined)  {
            //   message.error('特色加分项3中说明为空,请填写');
            //   return false
            // }
            let o = {indicatorid:data.data.indicatorid9,fillin:data.data.fillin10,name:data.data.itemname8}
            const session = sessionStorage.getItem('id_11')
            if (session!==null && session!=='') {
              o.id = session
            } else {
              keysarr.forEach(item=>{
                if (item.includes('id11')){
                  const a = item.split('_')
                  o.id = a[2]
                }
              })
            }
            arr.push(o)
          }
          if (data.data.indicatorid13 !== ''){
            // if (data.data.itemname12 === '' || data.data.itemname12 === null || data.data.itemname12 === undefined) {
            //   message.error('特色加分项4中名字为空,请填写');
            //   return false
            // }
            // if (data.data.fillin14 === '' || data.data.fillin14 === null || data.data.fillin14 === undefined)  {
            //   message.error('特色加分项4中说明为空,请填写');
            //   return false
            // }
            let o = {indicatorid:data.data.indicatorid13,fillin:data.data.fillin14,name:data.data.itemname12}
            const session = sessionStorage.getItem('id_15')
            if (session!==null && session!=='') {
              o.id = session
            } else {
              keysarr.forEach(item=>{
                if (item.includes('id15')){
                  const a = item.split('_')
                  o.id = a[2]
                }
              })
            }

            arr.push(o)
          }
          if (data.data.indicatorid17 !== ''){
            // if (data.data.itemname16 === '' || data.data.itemname16 === null || data.data.itemname16 === undefined) {
            //   message.error('特色加分项5中名字为空,请填写');
            //   return false
            // }
            // if (data.data.fillin18 === '' || data.data.fillin18 === null || data.data.fillin18 === undefined)  {
            //   message.error('特色加分项5中说明为空,请填写');
            //   return false
            // }
            let o = {indicatorid:data.data.indicatorid17,fillin:data.data.fillin18,name:data.data.itemname16}
            const session = sessionStorage.getItem('id_19')
            if (session!==null && session!=='') {
              o.id = session
            } else {
              keysarr.forEach(item=>{
                if (item.includes('id19')){
                  const a = item.split('_')
                  o.id = a[2]
                }
              })
            }
            arr.push(o)
          }
          this.onSubmitHandler(arr)
        }
      }
    })
  }
  //下一步
  onCancel(data){
    Modal.confirm({
      content: '确认提交数据到下一个填报页面?',
      okText: '确认',
      cancelText: '取消',
      onOk:()=>{
        if (data.status) {
          let isEmpty = true;
          Object.keys(data.data).forEach(function(x) {
            if(data.data[x] != null && data.data[x] != ""){
              isEmpty = false;
            }
          });
          if (isEmpty) {
            message.error('您还未添加特色加分项');
            return false
          }
          const arr = []
          let keysarr = [];
          for (let key in data.data) {
            if (key.includes('_id')){
              keysarr.push(key)
            }
          }
          if (data.data.indicatorid1 !== ''){
            // if (data.data.itemname0 === '' || data.data.itemname0 === null || data.data.itemname0 === undefined) {
            //   message.error('特色加分项1中名字为空,请填写');
            //   return false
            // }
            // if (data.data.fillin2 === '' || data.data.fillin2 === null || data.data.fillin2 === undefined)  {
            //   message.error('特色加分项1中说明为空,请填写');
            //   return false
            // }
            let o = {indicatorid:data.data.indicatorid1,fillin:data.data.fillin2,name:data.data.itemname0}
            const session = sessionStorage.getItem('id_3')
            if (session!==null && session!=='') {
              o.id = session
            } else {
              keysarr.forEach(item=>{
                if (item.includes('id3')){
                  const a = item.split('_')
                  o.id = a[2]
                }
              })
            }
            arr.push(o)
          }
          if (data.data.indicatorid5 !== ''){
            // if (data.data.itemname4 === '' || data.data.itemname4 === null || data.data.itemname4 === undefined) {
            //   message.error('特色加分项2中名字为空,请填写');
            //   return false
            // }
            // if (data.data.fillin6 === '' || data.data.fillin6 === null || data.data.fillin6 === undefined)  {
            //   message.error('特色加分项2中说明为空,请填写');
            //   return false
            // }
            let o = {indicatorid:data.data.indicatorid5,fillin:data.data.fillin6,name:data.data.itemname4}
            const session = sessionStorage.getItem('id_7')
            if (session!==null && session!=='') {
              o.id = session
            } else {
              keysarr.forEach(item=>{
                if (item.includes('id7')){
                  const a = item.split('_')
                  o.id = a[2]
                }
              })
            }
            arr.push(o)
          }
          if (data.data.indicatorid9 !== ''){
            // if (data.data.itemname8 === '' || data.data.itemname8 === null || data.data.itemname8 === undefined) {
            //   message.error('特色加分项3中名字为空,请填写');
            //   return false
            // }
            // if (data.data.fillin10 === '' || data.data.fillin10 === null || data.data.fillin10 === undefined)  {
            //   message.error('特色加分项3中说明为空,请填写');
            //   return false
            // }
            let o = {indicatorid:data.data.indicatorid9,fillin:data.data.fillin10,name:data.data.itemname8}
            const session = sessionStorage.getItem('id_11')
            if (session!==null && session!=='') {
              o.id = session
            } else {
              keysarr.forEach(item=>{
                if (item.includes('id11')){
                  const a = item.split('_')
                  o.id = a[2]
                }
              })
            }
            arr.push(o)
          }
          if (data.data.indicatorid13 !== ''){
            // if (data.data.itemname12 === '' || data.data.itemname12 === null || data.data.itemname12 === undefined) {
            //   message.error('特色加分项4中名字为空,请填写');
            //   return false
            // }
            // if (data.data.fillin14 === '' || data.data.fillin14 === null || data.data.fillin14 === undefined)  {
            //   message.error('特色加分项4中说明为空,请填写');
            //   return false
            // }
            let o = {indicatorid:data.data.indicatorid13,fillin:data.data.fillin14,name:data.data.itemname12}
            const session = sessionStorage.getItem('id_15')
            if (session!==null && session!=='') {
              o.id = session
            } else {
              keysarr.forEach(item=>{
                if (item.includes('id15')){
                  const a = item.split('_')
                  o.id = a[2]
                }
              })
            }

            arr.push(o)
          }
          if (data.data.indicatorid7 !== ''){
            // if (data.data.itemname16 === '' || data.data.itemname16 === null || data.data.itemname16 === undefined) {
            //   message.error('特色加分项5中名字为空,请填写');
            //   return false
            // }
            // if (data.data.fillin18 === '' || data.data.fillin18 === null || data.data.fillin18 === undefined)  {
            //   message.error('特色加分项5中说明为空,请填写');
            //   return false
            // }
            let o = {indicatorid:data.data.indicatorid17,fillin:data.data.fillin18,name:data.data.itemname16}
            const session = sessionStorage.getItem('id_19')
            if (session!==null && session!=='') {
              o.id = session
            } else {
              keysarr.forEach(item=>{
                if (item.includes('id19')){
                  const a = item.split('_')
                  o.id = a[2]
                }
              })
            }
            arr.push(o)
          }
          this.onSubmitHandler(arr,'tz')
        }
      }
    })
  }

  onSubmitHandler(data, type=''){
      const params = {}
      params.annual = localStorage.getItem('year')
      params.itemlist = data
      savedataspecial(params).then(res=>{
        if(res.statecode === 0) {
          this.props.refreshMenu(true)
          message.success('保存成功');
           if (type === 'tz'){
            gotonext()
            this.props.history.push({
              pathname: '/home',
            });
          }
        } else {
          message.error(res.statemessage);
        }
      })
  }

  componentDidMount(){
      this.onSelect()
  }

  componentWillUnmount(){
    removeStorage('id_3','session')
    removeStorage('id_7','session')
    removeStorage('id_11','session')
    removeStorage('id_15','session')
    removeStorage('id_19','session')
  }

  render(){
    return (
      <div className='store-manage-list-new' id='top'>
        <div style={{width:'100%',textAlign:'center'}}><h2>特色加分项</h2></div>
        <CPageNew
            data={this.state.data}
            onChange={this.onChange}
            onSearch={this.onSearch}
            onSubmit={this.onSubmit}
            onCancel={this.onCancel}
            onChangeEdit={this.onChangeEdit}
        />
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    year: state.year,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    refreshMenu: bindActionCreators(refreshMenu, dispatch),
  };
};
export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Legal);

